import type { FC } from 'react';

import { StateProvider } from '../contexts';
import { useReducerState } from '../hooks';

export const StateContainer: FC = ({ children }) => {
  const state = useReducerState({ currentStep: 0 });

  return <StateProvider value={state}>{children}</StateProvider>;
};
